import React from 'react'
import { Box } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { PageContextProvider } from 'pageContext'
import { useManagementRole } from 'hooks'
import AddNewAssignment from 'components/Popups/AddNewAssignment/AddNewAssignment'
import { RESOURCE_TYPE_NAMES } from 'utils'

const AddNewSetGroup = ({ protectedsubcomponent, managementRoleId }) => {
    const { data: managementRole } = useManagementRole(managementRoleId)
    return (
        <Box data-protectedsubcomponent={protectedsubcomponent}>
            <PageContextProvider
                key={'OtherTypesManagementRoleSetGroupMembers'}
            >
                <AddNewAssignment
                    resourceType={RESOURCE_TYPE_NAMES.MANAGEMENT_ROLES}
                    labelKey={'AddSetGroupAsMember'}
                    searchUrl={`api/ManagementRoles/unassignedMembers/setgroups/${managementRoleId}`}
                    targetAssigneeId={managementRoleId}
                    targetAssigneeResource={managementRole}
                    searchPlaceHolder="SearchSetGroups"
                    queryParams={{}}
                    hideDurationSelection={true}
                    startIcon={
                        <Icon
                            name={'Plus'}
                            fill="white"
                            style={{
                                width: '16px',
                                height: '16px',
                                marginTop: '0px',
                                marginRight: '5px',
                            }}
                        />
                    }
                />
            </PageContextProvider>
        </Box>
    )
}

export default AddNewSetGroup
